export default {
	dataIterator: {
		rowsPerPageText: 'Stück pro Seite',
		rowsPerPageAll: 'Alle',
		pageText: '{0}-{1} von {2}',
		noResultsText: 'Kein Resultat',
		nextPage: 'Nächste Seite',
		prevPage: 'Vorherige Seite'
	},
	dataTable: {
		rowsPerPageText: 'Zeilen pro Seite:'
	},
	noDataText: 'Keine verfügbare Daten'
}
